import { useSelector } from 'react-redux';
import { ThemeProvider as MuiThemeProvider } from '@emotion/react';
import themeCreator from '@mvf/external-components/Themes/themeCreator';
import React from 'react';
import FEATURES from '../../Data/features';

const ThemeProvider = ({ children }) => {
  const { fontOverride } = useSelector((store) => store.optionalFormConfig);
  const { palette } = useSelector((store) => store.theme);
  const { featureFlags } = useSelector((store) => store.formConfig);

  const fontFamily = fontOverride?.fontFamily
    ? fontOverride?.fontFamily
    : "'Arial', sans-serif";

  const theme = themeCreator(
    palette,
    fontFamily,
    featureFlags.includes(FEATURES.LARGER_TEXT) ? 1.3 : 1
  );

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
